import React from 'react'
import Button from '@atlaskit/button'
import * as Sentry from '@sentry/react'

Sentry.init({
  environment: process.env.ENVIRONMENT || 'development',
  dsn: 'https://a87991b0cc3944c7b71fa6f143e99466@o506677.ingest.sentry.io/6046509',
  ignoreErrors: ['AP is not defined', 'ResizeObserver', 'Loading chunk'],
  denyUrls: [/extensions\//i, /^chrome:\/\//i],
})

const ErrorFallback = ({ children }) => (
  <Sentry.ErrorBoundary
    fallback={({ eventId, resetError }) => (
      <div className="error">
        <div className="error-inner">
          <div className="error-title">
            <div className="error-emoji">😮</div>
            <div className="error-message">
              An error occurred! For help or to be notified when it&apos;s fixed
              please email this ID to{' '}
              <a
                href={`mailto:support@appsplus.co?body=Error ID: ${eventId}`}
                target="_blank"
                rel="noreferrer"
              >
                support@appsplus.co
              </a>
            </div>
          </div>
          <div className="error-id">{eventId}</div>
          <Button
            appearance="primary"
            shouldFitContainer
            onClick={() => resetError()}
          >
            Refresh App
          </Button>
        </div>
      </div>
    )}
  >
    {children}
  </Sentry.ErrorBoundary>
)

export default ErrorFallback
